export default __webpack_public_path__ + "static/media/slider.a0333c3b.gif";